import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    info: null,
    token: null,
  },
  reducers: {
    userLogin: (state, action) => {
      state.info = action.payload.user;
      state.token = action.payload.token;
    },
    logout: (state) => {
      state.info = null;
      state.token = null;
    },
  },
});

export const { userLogin, logout } = userSlice.actions;

export default userSlice.reducer;
